// src/api/ticketLinkTypeService.js
// -----------------------------------------------------------------------------
// REST API connected service for Ticket_Link_Type_TBL.
// Connects CRUD operations directly to the C# Web API backend endpoints.
// -----------------------------------------------------------------------------
import axiosClient from './axiosClient';

const ticketLinkTypeService = {
  getAll: () => {
    return axiosClient.get('/TicketLinkType')
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("GET /TicketLinkType returned 404. Falling back to GET /ticket-link-types...");
          return axiosClient.get('/ticket-link-types');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map((item) => ({
          linkTypeID: item.linkTypeId || item.linkTypeID || 0,
          linkTypeName: item.linkTypeName || '',
        }));
        return {
          data: mappedList,
        };
      });
  },

  getById: (id) => {
    return axiosClient.get(`/TicketLinkType/${id}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET /TicketLinkType/${id} returned 404. Falling back to GET /ticket-link-types/${id}...`);
          return axiosClient.get(`/ticket-link-types/${id}`);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: {
            linkTypeID: raw.linkTypeId || raw.linkTypeID || 0,
            linkTypeName: raw.linkTypeName || '',
          },
        };
      });
  },

  create: (payload) => {
    const body = {
      linkTypeId: 0,
      linkTypeName: payload.linkTypeName,
    };
    return axiosClient.post('/TicketLinkType', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("POST /TicketLinkType returned 404. Falling back to POST /ticket-link-types...");
          return axiosClient.post('/ticket-link-types', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: {
            linkTypeID: raw.linkTypeId || raw.linkTypeID || 0,
            linkTypeName: raw.linkTypeName || '',
          },
        };
      });
  },

  update: (id, payload) => {
    const body = {
      linkTypeId: Number(id),
      linkTypeName: payload.linkTypeName,
    };
    return axiosClient.put('/TicketLinkType', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("PUT /TicketLinkType returned 404. Falling back to PUT /ticket-link-types...");
          return axiosClient.put('/ticket-link-types', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: {
            linkTypeID: raw.linkTypeId || raw.linkTypeID || 0,
            linkTypeName: raw.linkTypeName || '',
          },
        };
      });
  },

  remove: (id) => {
    return axiosClient.delete(`/TicketLinkType/${id}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`DELETE /TicketLinkType/${id} returned 404. Falling back to DELETE /ticket-link-types/${id}...`);
          return axiosClient.delete(`/ticket-link-types/${id}`);
        }
        return Promise.reject(err);
      });
  },
};

export default ticketLinkTypeService;
